var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V2C14 0.895431 13.1046 0 12 0H2ZM9.78223 6.16402C10.0724 5.89788 10.0726 5.46621 9.78262 5.19986C9.49263 4.93352 9.02228 4.93336 8.73207 5.1995L6.38225 7.35445L5.26793 6.33253C4.97772 6.06639 4.50737 6.06655 4.21738 6.3329C3.92739 6.59924 3.92756 7.03091 4.21777 7.29705L5.85718 8.8005C6.14723 9.0665 6.61728 9.0665 6.90733 8.8005L9.78223 6.16402Z","fill":"currentColor"}));
}

Checkbox.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
